import { useMemo } from 'react';
import { SearchTable } from './SearchTable';
import {
  dummyConfig,
  getBrandPortalTableColumns
} from './columns/BrandPortalTableColumns';
import { EventSearchDocument } from 'types/Search';
import { UnionCustomAttributeProps } from 'components/common/Portals/CustomAttributes/types';
import { useBrandPortalColumnManagement } from './hooks/useBrandPortalColumnManagement';
import { useBrandPortalEventKey } from 'hooks/useBrandPortalEventKey';
import { columnConfiguration } from 'components/constants/Constants';
import { MRT_Row } from 'material-react-table';
import { SearchViewPropsExtended } from './types';
type SearchTableProps<T extends object> = {
  customAttributesDefinitions: {
    data?: UnionCustomAttributeProps[];
    loading: boolean;
    error: boolean;
  };
} & SearchViewPropsExtended<T>;

export const BrandPortalTable: React.FC<
  SearchTableProps<EventSearchDocument>
> = props => {
  const columns = useMemo(
    () => getBrandPortalTableColumns(props.customAttributesDefinitions.data),
    [props.customAttributesDefinitions.data]
  );
  const eventKey = useBrandPortalEventKey();
  const columnConfigColumns = columnConfiguration.find(
    el => el.eventKey === eventKey
  )?.fields;

  const { columnOrder, setColumnOrder, columnVisibility, setColumnVisibility } =
    useBrandPortalColumnManagement(eventKey, columnConfigColumns, columns);

  const generateProductPageLink = (row: MRT_Row<EventSearchDocument>) => {
    if (!row.original.event?.event?.key) return '';
    return `/events/${row.original.event.event.key}/product/${row.original.old_key}`;
  };

  return (
    <SearchTable<EventSearchDocument>
      {...props}
      getRowId={row => row.id}
      columns={columns ?? dummyConfig}
      generateItemPageLink={generateProductPageLink}
      columnManagement={{
        columnOrder,
        setColumnOrder,
        columnVisibility,
        setColumnVisibility
      }}
    />
  );
};
